import type { NextPage } from "next";
import CoachPage from "../../src/pages/Coach/CoachPage";
import { getStaticProps as gsp, getStaticPaths as gspaths } from "locales/utils";

const Coach: NextPage = () => {
  return <CoachPage />;
};

export default Coach;

export const getStaticProps = gsp;

export const getStaticPaths = gspaths;
